export const smallLogo = ['320 134', `
  <title>快乐念住</title>
  <g xmlns="http://www.w3.org/2000/svg">
    <title>快乐念住logo</title>
    <text font-weight="bold" transform="matrix(1.57 0 0 1.60714 -3.99 -4.85714)" stroke="#000" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="50" id="svg_2" y="53" x="7" stroke-width="0" fill="#3c4b64">快乐念住</text>
 </g>
`]
